import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    CreateCompanyDirectionPayload,
    DirectionsCreateDirectionResponseT,
    DirectionsCreatePayloadT,
    DirectionsGetCitiesForDirectionsResponseT,
    DirectionsGetListParamsT,
    DirectionsGetListResponseT,
    DirectionsUpdateDirectionResponseT,
    GetCompanyDirectionDetailsResponse,
    GetCompanyDirectionsListResponse,
    GetCompanyDirectionsParams,
    UpdateCompanyDirectionPayload,
} from '../types/directions.types'

export class DirectionsRepository {
    getList(params: DirectionsGetListParamsT): Promise<AxiosResponse<DirectionsGetListResponseT>> {
        return http.get('/location/api/directions', { params })
    }

    createDirection(
        payload: DirectionsCreatePayloadT
    ): Promise<AxiosResponse<DirectionsCreateDirectionResponseT>> {
        return http.post('/location/api/directions', payload)
    }

    updateDirection(
        direction_id: number,
        zoneId: number,
        isNearbyCities: number
    ): Promise<AxiosResponse<DirectionsUpdateDirectionResponseT>> {
        return http.put(`/location/api/directions/${direction_id}`, {
            zoneId: zoneId,
            isNearbyCities: isNearbyCities,
        })
    }

    getCitiesForDirections(): Promise<AxiosResponse<DirectionsGetCitiesForDirectionsResponseT>> {
        return http.get('/cabinet/api/order/create')
    }

    importFromExcel(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/location/api/directions/import', form_data)
    }

    deleteDirection(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/location/api/directions/${id}`)
    }

    getCompanyDirections(params: GetCompanyDirectionsParams): Promise<AxiosResponse<GetCompanyDirectionsListResponse>> {
        return http.get('/location/api/company-directions', { params })
    }
    
    getCompanyDirectionDetails(companyDirectionId: number): Promise<AxiosResponse<GetCompanyDirectionDetailsResponse>> {
        return http.get(`/location/api/company-directions/${companyDirectionId}`)
    }

    createCompanyDirection(payload: CreateCompanyDirectionPayload): Promise<AxiosResponse<void>> {
        return http.post('/location/api/company-directions', payload)
    }

    updateCompanyDirection(companyDirectionId: number, payload: UpdateCompanyDirectionPayload): Promise<AxiosResponse<void>> {
        return http.put(`/location/api/company-directions/${companyDirectionId}`, payload)
    }

    deleteCompanyDirection(companyDirectionId: number): Promise<AxiosResponse<void>> {
        return http.delete(`/location/api/company-directions/${companyDirectionId}`)
    }
}
